// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"7a02ba52f4cabd9489b8","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"45deed5eaad3d5d22034","vendors-node_modules_rehype-highlight_index_js":"70a4778e6219bb956045"}[chunkId] + "";
};